<template>
  <div class="animated fadeIn">
    <b-breadcrumb><strong>All Records</strong></b-breadcrumb>
    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">

    <!-- <b-table
      :borderless="borderless"
      :hover="hover"
      :items="items"
      :fields="fields"
      :head-variant="headVariant"
      :table-variant="tableVariant"
    ></b-table> -->
    <br>
    <tr>
            &nbsp;&nbsp;<td><button type="button" class="btn btn-light" style="color: #a64dff;" v-on:click="AllRecords()">All Records </button></td>&nbsp;&nbsp;&nbsp;
            <td><button type="button" class="btn btn-light" style="color: #a64dff;" v-on:click="Approvedlist()">Approved </button></td>&nbsp;&nbsp;&nbsp;
            <td><button type="button" class="btn btn-light" style="color: #a64dff;" v-on:click="NotApprovedlist()">Not Approved </button></td>
            <td><div>
<!--     <b-pagination v-model="currentPage" pills :total-rows="rows" id="pageno" style="margin-left: 370px;"></b-pagination> -->
  </div>
</td>
        </tr>
        <br>
        <div id="adduser"  style="padding: .75rem 1.25rem;border: 1px solid rgba(0,0,0,.125);" class="mb-1">
          
    <table class="table">
        
        <thead class="theader">
                <th>Sr. No.</th>
                <th>DESIGN</th>
                <th>FACTORY</th>
                <th>QUANTITY</th>
                <th>TARGET PRICE</th> 
                <th>QUOTE</th>
                <th>Status</th>
        </thead>
        <tbody v-if="totalRows>0">
            <tr class="table table-hover" v-for="(value, firstIndex) in quatationdata">
                <td>{{firstIndex+1}}</td>
                <td>
                    <span id="design"><b>{{value.design_title}}</b></span><br><span><img 
                      v-bind:src="value.design_image" img alt="This image is not available" id="logo"></span>                
                    &nbsp;
                    <span id="design">{{value.design_id}}</span>  
                </td>
                 <td><span><b>FC-One</b></span>
                </td>
                <td><span>{{value.quantity}}</span>
                </td>
               	<td>
                    <span>--</span>
                </td>

                <td><span>{{value.quantity_currency}}  {{value.price_per_garment}}</span>
                </td>
               
                
 <td >
                <span v-if="value.status=='0'" style="color: Orange"><b>In Progress</b></span>

                <span v-if="value.status=='1'" style="color: Green"><b>Approved</b></span>

                <span v-if="value.status=='2'" style="color: red"><b>Rejected</b></span>

                <br>
                    <span>{{value.created_date}}</span>
                </td>
                
            </tr>

            <!-- <tr>
                <td>
                    <span id="design"><b>Tiny Pink Polka Dress</b></span><br><span><img src="../assets/images/pink_polka.jpeg" id="logo"></span>                
                    &nbsp;
                    <span id="design">ID:FCLFJY005</span>   
                </td>
                <td><span><b>FC-One</b></span>
                </td>
                <td>
                    <span>0Pcs</b></span>
                </td>
                <td>
                    <span>--</b></span>
                </td>
                <td><span>INR 175</span>
                </td>
                <td><span style="color: #32CD32"><b>Approved</b></span><br>
                    <span>2 months ago</span>
                </td>
            </tr> -->

            
        </tbody>
        <tbody v-if="totalRows==0">
            <tr>
                <td id="td_recs">No Records Found</td>
            </tr>
        </tbody>
    </table>
</div>
    </b-card>
    </b-col>
    </b-row>
    </div>
</template>


<script>
import CONSTANTS from '@/utils/constants';
import auth from '@/utils/auth';
import Vue from 'vue';



const axios = require('axios')

  export default {
    data() {
      return {
        fields: ['DESIGN', 'REQUESTED_SAMPLE', 'FACTORY', 'STATUS'],
        items: [
          { DESIGN:'Kartik Tshirt', REQUESTED_SAMPLE: 'Prototype/Fit Sample', FACTORY: 'FC-One', STATUS: 'Approved' },
          { DESIGN:'Tiny Pink Polka Dress', REQUESTED_SAMPLE: 'Preproduction Sample', FACTORY: 'FC-One', STATUS: 'Approved' },
          { DESIGN:'Blue smiley Half Sleeve... ', REQUESTED_SAMPLE: 'Preproduction Sample', FACTORY: 'FC-One', STATUS: 'Approved' },
          { DESIGN:'Navy smiley Full Sleeve... ', REQUESTED_SAMPLE: 'Preproduction Sample', FACTORY: 'FC-One', STATUS: 'Approved' },
          { DESIGN:'Tiny Navy Polka Dress', REQUESTED_SAMPLE: 'Preproduction Sample', FACTORY: 'FC-One', STATUS: 'Approved' },
          { DESIGN:'Yello Printed Dress White...', REQUESTED_SAMPLE: 'Prototype/Fit Sample', FACTORY: 'FC-One', STATUS: 'Approved' },
          // { DESIGN:' ', REQUESTED_SAMPLE: 'Preproduction Sample', FACTORY: 'FC-One', STATUS: 'Approved' },
          // { DESIGN:' ', REQUESTED_SAMPLE: 'Preproduction Sample', FACTORY: 'FC-One', STATUS: 'Approved' },
          // { DESIGN:' ', REQUESTED_SAMPLE: 'Preproduction Sample', FACTORY: 'FC-One', STATUS: 'Approved' },
          // { DESIGN:' ', REQUESTED_SAMPLE: 'Preproduction Sample', FACTORY: 'FC-One', STATUS: 'Approved' },
          // { DESIGN:' ', REQUESTED_SAMPLE: 'Preproduction Sample', FACTORY: 'FC-One', STATUS: 'Approved' },

        ],
        quatationdata: [],
        totalRows: 0,
        borderless: false,
        hover: true,
        headVariant: null,
        tableVariant: '',
        rows: 100,
        currentPage: 1
      }
      // methods: {
      //       Approvedlist(){
      //           this.$router.push('/approved');
      //       }
      // }
    },
     created: function () {
        this.quatationrecords()
    },
     methods: {
    Approvedlist: function(){
                 this.$router.push('/approved').catch(()=>{});
    },
    NotApprovedlist: function(){
                 this.$router.push('/notapproved').catch(()=>{});
    },
    AllRecords: function(){
                 this.$router.push('/allrecords').catch(()=>{});
    },


    quatationrecords: function () {

    this.isBusy = true;
    
      var userData = localStorage.getItem('userData');
      if (userData) 
      {

        var userInfo = JSON.parse(userData)
        this.vendor_id = userInfo[0].vendor_id; 

        
        const Obj={
              vendor_id: this.vendor_id,
              status: ''
            }
        axios.post(`${CONSTANTS.API_URL}/quatationdetails`,Obj)
        .then(response => {
          this.result = response.data;
          if (this.result.returnmsg === 'Successful') {

            this.quatationdata  = this.result.returnvalue;
            this.totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;
          }else {
           this.category_list =[];
           this.totalRows=0;
             this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })



      }  

},

}
  };
</script>
<style type="text/css">
    #logo{
            width: 40px;
            height: 50px;
    }
    #design{
        /*margin-left: 43px;*/
    }
    #pageno{
        float:right;
        position: absolute;
        margin-left: 100px;
    }
    #td_recs{
      position: absolute;
    margin-left: 444px;
    }
    
</style>